import { CSSProperties, memo, PropsWithChildren } from 'react';
import { useCarousel } from '../use-carousel';
import { CarouselContext } from '../carousel.context';

type RootProps = {
  index: number;
  total: number;
  onSlideChange?: () => void;
  onNavigate: (dir: -1 | 1) => void;
  onSwipeDown?: () => void;
  onSwipeUp?: () => void;
  onTap?: () => void;
  keyboard?: boolean;
  style?: CSSProperties;
  className?: string;
};

export const Root = memo(
  ({
    index,
    total,
    onSlideChange,
    onNavigate,
    onSwipeDown,
    onSwipeUp,
    onTap,
    keyboard = true,
    style,
    className,
    children,
  }: PropsWithChildren<RootProps>) => {
    const carousel = useCarousel({
      index,
      total,
      onNavigate,
      onSwipeDown,
      onSwipeUp,
      onTap,
      keyboard,
    });

    return (
      <CarouselContext.Provider
        value={{
          index,
          total,
          ref: carousel.ref,
          trackStyle: carousel.trackStyle,
          pointerHandlers: carousel.pointerHandlers,
        }}
      >
        <div
          ref={carousel.ref}
          style={{
            position: 'relative',
            touchAction: 'none',
            userSelect: 'none',
            ...style,
          }}
          className={className}
          {...carousel.pointerHandlers}
        >
          {children}
        </div>
      </CarouselContext.Provider>
    );
  }
);

Root.displayName = 'Carousel.Root';
